import React from 'react';
import 'dotenv/config';

import Home2 from '../Containers/Home2';
import HomeBV from '../Containers/HomeBV';
import HomeBancoInter from '../Containers/HomeBancoInter';
import HomeTheNail from '../Containers/HomeTheNail';
import HomeBrasilAdm from '../Containers/HomeBrasilAdmIndividual';
import HomeBrasiladmVida from '../Containers/HomeBrasiladmVida';
import HomeBrasiladmFidelidade from '../Containers/HomeBrasiladmFidelidade';
import HomeEMED from '../Containers/HomeEMED';
import Cargox from '../Containers/HomeCargox';
import HomeCaarj from '../Containers/HomeCAARJ';
import HomeAltbank from '../Containers/HomeAltBank';
import HomeMarisa from '../Containers/HomeMarisa';
import UserList from '../Containers/UserList';
import EpaySuccess from '../Containers/EpaySuccess';
import Beneficiario from '../Containers/Beneficiario';
import EnderecoBeneficiario from '../Containers/EnderecoBeneficiario';
import Carrinho from '../Containers/Carrinho';
import Pagamento from '../Containers/Pagamento';
import Sucesso from '../Containers/Sucesso';
import EnderecoEntrega from '../Containers/EnderecoEntrega';
import Erro from '../Containers/Erro';
import HomeFidelidade from '../Containers/HomeFidelidade';
import HomeEpay from '../Containers/HomeEpay';
import HomeCmDrConsulta from '../Containers/HomeCmDrConsulta';
import HomeVivo from '../Containers/HomeVivo';
import VivoSuccess from '../Containers/VivoSuccess';
import HomeLevelled from '../Containers/HomeLevelled';
import LevelledSuccess from '../Containers/LevelledSuccess';

import VivoAuth from '../Containers/VivoAuth';
// import Sidebar from '../Components/Sidebar';

import { Route, withRouter } from 'react-router-dom';

import './index.scss';
import { ThemeProvider } from 'styled-components';
import Container from '../style/styledComponents/Container';
import ThemeSelector from '../style/themes/ThemeSelector';

function App() {
	// const RouteSidebar = withRouter(props => <Sidebar {...props} />);
	return (
		<ThemeProvider theme={ThemeSelector()}>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/userList'}
				component={UserList}
			/>
			<Route exact path={process.env.PUBLIC_URL + '/'} component={Home2} />
			<Route
				exact
				path={process.env.PUBLIC_URL + '/fidelidade'}
				component={HomeFidelidade}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/bancointer'}
				component={HomeBancoInter}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/thenail'}
				component={HomeTheNail}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/brasiladmindividual'}
				component={HomeBrasilAdm}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/fretebras'}
				component={Cargox}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/altbank'}
				component={HomeAltbank}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/brasiladmvida'}
				component={HomeBrasiladmVida}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/brasiladmfidelidade'}
				component={HomeBrasiladmFidelidade}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/emed'}
				component={HomeEMED}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/caarj'}
				component={HomeCaarj}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/marisa'}
				component={HomeMarisa}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/epay'}
				component={HomeEpay}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/levelled'}
				component={HomeLevelled}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/cmdrconsulta'}
				component={HomeCmDrConsulta}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/vivoavulso'}
				component={HomeVivo}
			/>
			<Route exact path={process.env.PUBLIC_URL + '/bv'} component={HomeBV} />
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/beneficiario'}
				component={Beneficiario}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/bem-vindo'}
				component={EpaySuccess}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/bem-vindo-levelled'}
				component={LevelledSuccess}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/sucessoCliente'}
				component={VivoSuccess}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/auth'}
				component={VivoAuth}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/enderecoBeneficiario'}
				component={EnderecoBeneficiario}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/carrinho'}
				component={Carrinho}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/pagamento'}
				component={Pagamento}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/enderecoEntrega'}
				component={EnderecoEntrega}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/sucesso'}
				component={Sucesso}
			/>
			<Route
				exact
				path={process.env.PUBLIC_URL + '/:loja/erro'}
				component={Erro}
			/>
			{/* <RouteSidebar></RouteSidebar> */}
		</ThemeProvider>
	);
}

export default App;
